import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../context/TranslationContext";
import { useCustomisation } from "../../context/CustomisationContext";

interface BackToLoginButtonProps {}

export const BackToLoginButton: React.FC<BackToLoginButtonProps> = () => {
  const navigate = useNavigate();
  const { translations } = useTranslation();
  const { customisations } = useCustomisation();

  const {
    LOGIN: { buttonsSettings: loginbuttonssettings },
    GPC: { buttonsSettings: gpcbuttonssettings },
  } = customisations.customisations;

  const linkButtonColor =
    loginbuttonssettings?.loginLinkColor ?? gpcbuttonssettings?.gpcLinkColor;

  const handleBackToLogin = () => {
    navigate(-1);
  };

  return (
    <Button
      startIcon={<ArrowBackIcon />}
      onClick={handleBackToLogin}
      sx={{
        bgcolor: "transparent !important",
        color: linkButtonColor,
        fontWeight: 600,
        fontSize: "0.875rem",
        "&:hover": {
          textDecoration: "underline",
        },
      }}
    >
      {
        translations.translations["forgot-password"].forgotPasswordForm
          ?.backTologin
      }
    </Button>
  );
};
